import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HousingPage = lazy(() => import('../pages/housing/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const ResidentsPage = lazy(() => import('../pages/residents/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NondiscriminationPage = lazy(() => import('../pages/nondiscrimination/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const AccessibilityPage = lazy(() => import('../pages/accessibility/page'));
const SafetyRulesPage = lazy(() => import('../pages/safety-rules/page'));
const VisitorPolicyPage = lazy(() => import('../pages/visitor-policy/page'));
const ExitPolicyPage = lazy(() => import('../pages/exit-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/housing',
    element: <HousingPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/apply',
    element: <ApplyPage />,
  },
  {
    path: '/residents',
    element: <ResidentsPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/nondiscrimination',
    element: <NondiscriminationPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/accessibility',
    element: <AccessibilityPage />,
  },
  {
    path: '/safety-rules',
    element: <SafetyRulesPage />,
  },
  {
    path: '/visitor-policy',
    element: <VisitorPolicyPage />,
  },
  {
    path: '/exit-policy',
    element: <ExitPolicyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;